import styled from "styled-components";
import BaseAvatar from "_c/Avatar";

export const Avatar = styled(BaseAvatar)`
  margin-top: 18px;
  @media (max-width: 575px) {
    margin-top: 0;
  }
`;
export const Sect = styled.div`
  padding-top: 18px;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  @media (max-width: 575px) {
    margin-left: 0;
  }
`;
export const Name = styled.span`
  font-size: 16px;
  color: var(--font-color-emp);
  font-weight: 600;
  transition: opacity 0.2s ease;
  :hover {
    opacity: 0.7;
  }
`;
export const When = styled.p`
  margin-top: 5px;
  font-size: 12px;
  color: var(--font-color-main);
`;
export const Quote = styled.p`
  font-weight: 500;
  margin-top: 0;
  margin-bottom: 18px;
  max-width: 450px;
  font-size: 16px;
  color: var(--font-color-main);
  @media (max-width: 1199px) {
    max-width: 400px;
  }
  @media (max-width: 767px) {
    max-width: 260px;
  }
  @media (max-width: 575px) {
    max-width: 100%;
    margin-top: 0;
  }
`;
export const Photo = styled.img`
  width: 100%;
  object-fit: cover;
  min-height: 100px;
  height: auto;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
`;
export const Figure = styled.figure`
  max-width: 100px;
  margin: 0;
  margin-right: 25px;
  margin-left: auto;
  padding-left: 25px;
  @media (max-width: 575px) {
    display: none;
  }
`;
export const MobileFigure = styled.figure`
  display: none;
  @media (max-width: 575px) {
    display: block;
    margin: 0;
    margin-top: 10px;
    margin-bottom: 20px;
  }
`;
export const ButtonSect = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 575px) {
    justify-content: center;
  }
  > button {
    margin-bottom: 7px;
    margin-left: 7px;
    :first-child {
      margin-left: 0;
    }
  }
`;
export const Wrap = styled.div`
  padding: 0 10px 10px 25px;
  margin-bottom: 10px;
  background: var(--bg-paper);
  border-radius: 7px;
  box-shadow: ${({ theme }) => theme.shadow[0]};
  @media (max-width: 575px) {
    width: 90%;
    margin: 0 auto;
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 15px;
  }
`;
export const InnerWrap = styled.div`
  display: flex;
  @media (max-width: 575px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 15px;
  }
`;
export const RemoveButton = styled.button`
  border: none;
  box-shadow: none;
  font-weight: 500;
  font-size: 13px;
  margin-left: 5px;
  :first-child {
    margin-left: 0;
  }
  color: var(--color-danger);
  transition: opacity 0.25s ease;
  :hover,
  :focus {
    opacity: 0.7;
  }
`;
